import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import vMasker from 'vanilla-masker'
import { TextField } from '@mui/material'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import FieldWrapper from '../FieldRowWrapper'
import {
  ensureEnglishNumber,
  toPersianDigit,
} from '../../../helpers/generalHelpers'
import settings from '../../../settings'

import './time-input.css'
import RawHtml from 'stories/components/RawHtml'

const { locales } = settings

class TimeInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
      maskedValue: '',
    }
  }

  maskTime = (rawValue) => vMasker.toPattern(rawValue, '99:99')

  addColon = (value) => {
    const { maskedValue } = this.state
    if (/^\d{2}:\d{1}$/.test(maskedValue) && /^\d{2}$/.test(value)) {
      return value.replace(':', '')
    } else if (/^\d{2}:$/.test(maskedValue) && /^\d{1}$/.test(value)) {
      return value.replace(':', '')
    } else if (/^\d{2}$/.test(value)) {
      return value + ':'
    } else {
      return value
    }
  }

  format24Hours = (timeString) => {
    if (/^\d{2}:\d{1}$/.test(timeString)) {
      return timeString.replace(':', ':0')
    }

    return '00:00'
      .split('')
      .map((placeholder, index) =>
        index + 1 > timeString.length ? placeholder : timeString[index]
      )
      .join('')
  }

  ensure24Hours = (timeString) => {
    switch (timeString.length) {
      case 0:
        return null
      case 1:
        return this.format24Hours('0' + timeString)
      default:
        return this.format24Hours(timeString)
    }
  }

  onInputChange = ({ target: { value } }) => {
    this.updateState({
      value,
      shouldUpdateParent: true,
    })
  }

  updateState = ({ value, shouldUpdateParent }) => {
    const maskedValue = this.addColon(this.maskTime(ensureEnglishNumber(value)))

    this.setState({ maskedValue }, () => {
      // we wish to keep the 00:00 format so no unMasking 💩
      shouldUpdateParent && this.props.onChange(this.ensure24Hours(maskedValue))
    })
  }

  onInputFocus = () => {
    this.setState({ hasFocus: true }, () => {
      this.props.onFocus && this.props.onFocus()
    })
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () =>
    this.shouldApplyMasking()
      ? toPersianDigit(this.state.maskedValue)
      : this.state.maskedValue

  componentDidMount = () => {
    const { value } = this.props
    if (value) {
      this.updateState({
        value: value,
        shouldUpdateParent: false,
      })
    } else {
      this.props.onChange(null)
    }
  }

  generateDescription = (desc, min, max) => {
    if (min && max)
      return (
        <>
          <FormattedMessage id="form.fields.time.range" values={{ max, min }} />
          <RawHtml content={desc} />
        </>
      )
    if (max)
      return (
        <>
          <FormattedMessage id="form.fields.time.to" values={{ max }} />
          <RawHtml content={desc} />
        </>
      )
    if (min)
      return (
        <>
          <FormattedMessage id="form.fields.time.from" values={{ min }} />
          <RawHtml content={desc} />
        </>
      )
    return ''
  }

  shouldApplyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  render() {
    const {
      label = '',
      name = '',
      placeholder = '00:00',
      required,
      touched,
      error,
      description,
      from_time,
      to_time,
      customized,
    } = this.props

    const classNames = {
      'formz-time-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }
    const inputProps = {
      type: 'text',
      name,
      value: this.getInputValue(),
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      placeholder,
    }

    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>

            <div className="formz-field-description">
              {this.generateDescription(description, from_time, to_time)}
            </div>

            <input {...inputProps} className="formz-input-field ltr-on-type" />
          </label>
        </FieldRowWrapper>
      )

    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <TextField {...inputProps} label={label} error={Boolean(error)} />
      </FieldWrapper>
    )
  }
}

export default injectIntl(TimeInput)
